import { ReactNode } from 'react'
import { NavLink } from 'react-router-dom'
import { MenuItemLayout } from './menu-item-layout'
import { MenuItemWithIconInCircle } from './menu-item-with-icon-in-circle'

const backRegex = /\bback\b/i

export function MenuItemWithIcon({
  className,
  ...props
}: {
  label: string
  link: string
  icon: ReactNode
  withIconInCircle?: boolean
  className?: string
}) {
  const { label, link, withIconInCircle } = props
  const isBackButton = backRegex.test(label)

  return (
    <NavLink
      to={link}
      className={className}
      style={{
        textDecoration: 'none',
      }}
    >
      {({ isActive }) =>
        withIconInCircle ? (
          <MenuItemWithIconInCircle {...props} isActive={isActive} />
        ) : (
          <MenuItemLayout {...props} isActive={!isBackButton && isActive} />
        )
      }
    </NavLink>
  )
}
